import React from "react";
import PropTypes from "prop-types";
/* Components */
import { Container, Row, Col } from "react-bootstrap";
import CustomTooltip from "@/components/CommonForBoth/CustomTooltip";
import PARowDesktop from "./PARowDesktop";
import PARowMobile from "./PARowMobile";
import Loader from "react-js-loader";
/* Helpers */
import { checkVisibility } from "@/helpers/ensuro_helper";
/* i18n */
import { withTranslation } from "react-i18next";
import "./../style.scss";

const paBadges = [];

const PAs = ({ t, pas, state, mode }) => {
  return (
    <Container className="no-margin">
      {state.loadingState !== "LOADED" || !pas.length ? (
        <div className="loader">
          <Loader
            type="spinner-default"
            color="#5B72E7"
            height={50}
            width={100}
            timeout={3000} //3 secs
          />
        </div>
      ) : (
        <>
          <Container className="desktop no-margin">
            <Row className="table-header">
              <Col md={3}>
                <strong>{t("Name")} </strong>
              </Col>
              <CustomTooltip text={t("ActivePoliciesTooltip")} placement="top">
                <Col md={1}>
                  <strong>{t("Active Policies")} </strong>
                  <span className="fa fa-info-circle" data-toggle="tooltip" data-original-title="Info" />
                </Col>
              </CustomTooltip>
              <CustomTooltip text={t("ActivePPTooltip")} placement="top">
                <Col md={3}>
                  <strong>{t("Active Pure Premiums")} </strong>
                  <span className="fa fa-info-circle" data-toggle="tooltip" data-original-title="Info" />
                </Col>
              </CustomTooltip>
              <CustomTooltip text={t("SurplusTooltip")} placement="top">
                <Col md={2}>
                  <strong>{t("Surplus")} </strong>
                  <span className="fa fa-info-circle" data-toggle="tooltip" data-original-title="Info" />
                </Col>
              </CustomTooltip>
              <CustomTooltip text={t("RMTooltip")} placement="top">
                <Col md={3}>
                  <strong>{t("Risk Modules")} </strong>
                  <span className="fa fa-info-circle" data-toggle="tooltip" data-original-title="Info" />
                </Col>
              </CustomTooltip>
            </Row>
          </Container>
          {pas.map(
            (pa) =>
              checkVisibility(pa, mode) && (
                <React.Fragment key={pa.address}>
                  <PARowDesktop idx={pa.address + "-Desktop"} pa={pa} paBadges={paBadges} />
                  <PARowMobile idx={pa.address + "-Mobile"} pa={pa} paBadges={paBadges} />
                </React.Fragment>
              )
          )}
        </>
      )}
    </Container>
  );
};

PAs.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(PAs);
